import { render } from "./NumberInput.vue?vue&type=template&id=b310fb4c&ts=true"
import script from "./NumberInput.ts?vue&type=script&lang=ts&external"
export * from "./NumberInput.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__